export default __webpack_public_path__ + "static/media/pagoefectivo_ecu_payment.194eee58.png";